export let getEnv = function(varName) {
    if (window.__ENV__) {
        getEnv = (varName) => window.__ENV__[varName];
        return getEnv(varName);
    }

    let isCRA = null;
    try {
        isCRA = process.env != null;
    } catch(e) {}

    if (isCRA) {
        getEnv = (varName) => process.env[varName];
    } else {
        getEnv = (varName) => import.meta.env[`VITE_${varName}`];
    }

    return getEnv(varName);
}
